// extracted by mini-css-extract-plugin
module.exports = {"gstBenefitCard":"GSTBenefit_gstBenefitCard__nrudo","gstIcon":"GSTBenefit_gstIcon__y_37C","gstText":"GSTBenefit_gstText__VUWdy"};